import {
  IonButton,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonIcon,
} from '@ionic/react';
import { arrowForward } from 'ionicons/icons';
import { useEffect, useState } from 'react';
import { useDispatch } from '../../../store/hooks';
import { checkLnrpStatus } from '../../../store/slices/lnrp.slice';
import './SelectPoolStep.scss';

interface Props {
  onNext: () => void;
  onSkip?: () => void;
}
const SelectPoolStep = ({ onNext, onSkip }: Props) => {
  const [selectedPools, setSelectedPools] = useState<string[]>([]);
  const dispatch = useDispatch();
  const poolNames = [
    'Barbangerz',
    'BPM Supreme',
    'Club Killers',
    'Country DJ Pool',
    'Crate Gang',
    'DJcity',
    'Digital DJ Pool',
    'Digital Music Pool',
    'Direct Music Service',
    'Doing The Damage',
    'Headliner Music Club',
    'Heavy Hits',
    'iDJPool',
    'Late Night Record Pool',
    'Latino Music Pool',
    'MP3 For DJs',
    'MyMP3Pool',
    'Radio DJ Pool',
    'Urban DJ Pool',
    'XMiX',
    'XtendaMix',
    'ZIPDJ',
    'Live DJ Service',
  ];

  useEffect(() => {
    const storedPools = JSON.parse(
      localStorage.getItem('selectedPools') as string,
    );
    setSelectedPools(storedPools || poolNames);

    dispatch(checkLnrpStatus());
  }, []);

  const updateLocalStorage = (newSelectedPools: string[]) => {
    localStorage.setItem('selectedPools', JSON.stringify(newSelectedPools));
  };

  const handleSelectAll = () => {
    setSelectedPools(poolNames);
    updateLocalStorage(poolNames);
  };

  const handleUnselectAll = () => {
    setSelectedPools([]);
    updateLocalStorage([]);
  };

  const handleCheck = (pool: string, isChecked: boolean) => {
    if (isChecked) {
      const newSelectedPools = [...selectedPools, pool];
      setSelectedPools(newSelectedPools);
      updateLocalStorage(newSelectedPools);
    } else {
      const newSelectedPools = selectedPools.filter(
        (selectedPool) => selectedPool !== pool,
      );
      setSelectedPools(newSelectedPools);
      updateLocalStorage(newSelectedPools);
    }
  };

  return (
    <div className="pool-card">
      <IonCard className="pool-preferences">
        <IonCardHeader>
          <h1 className="card-description">
            Next, choose which music pools to include in your searches and
            downloads
          </h1>
        </IonCardHeader>
        <IonCardContent>
          <div className="pool-selection-header">
            <div className="pool-selection-info">
              <span className="pool-count">
                {selectedPools.length} of {poolNames.length} pools selected
              </span>
            </div>
            <div className="pool-selection-actions">
              <IonButton
                disabled={selectedPools.length === poolNames.length}
                fill="clear"
                size="small"
                onClick={handleSelectAll}
              >
                Select All
              </IonButton>
              <IonButton
                disabled={selectedPools.length === 0}
                fill="clear"
                size="small"
                onClick={handleUnselectAll}
              >
                Clear All
              </IonButton>
            </div>
          </div>

          <div className="pool-grid-modern">
            {poolNames.map((pool) => (
              <div key={pool} className="pool-item-modern">
                <label className="pool-label-modern">
                  <input
                    type="checkbox"
                    className="pool-checkbox-large"
                    checked={selectedPools.includes(pool)}
                    onChange={(e) => handleCheck(pool, e.target.checked)}
                  />
                  <span className="pool-name">{pool}</span>
                </label>
              </div>
            ))}
          </div>
          <div className="next-button-container">
            <IonButton
              expand="block"
              className="next-button"
              onClick={onNext}
              //   disabled={selectedPools.length === 0}
            >
              Continue <IonIcon slot="end" icon={arrowForward} />
            </IonButton>
          </div>

          {onSkip && (
            <div className="bottom-skip">
              <IonButton
                expand="block"
                fill="clear"
                color="medium"
                onClick={onSkip}
              >
                SKIP FOR NOW - GO TO THE CRATE BUILDER
              </IonButton>
            </div>
          )}
        </IonCardContent>
      </IonCard>
    </div>
  );
};

export default SelectPoolStep;
